import Root from "../Root.vue";
import VueRouter from "vue-router";
import { customerOrderStore } from "../customerOrderStore";
import { Vue } from "vue-ext";
Vue.mixin({
    computed: {
        $customerOrderStore: function () { return customerOrderStore; },
    },
});
new Root({
    router: new VueRouter({
        linkActiveClass: "active",
        routes: [
            { path: "/", component: require("./OrderCreateView").default },
            { path: "/nouto", component: require("./OrderCreateRetrievalView").default },
            { path: "/kiitos", component: require("./ThanksView").default },
        ],
    })
})
    .$mount("#weee-root");
